import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { UserInfo } from "../../../shared/types/user-info";
import { MaintenanceProviderTableService } from "./maintenance-provider-table.service";
import { MaintenanceProvider } from "./maintenance-provider.types";

@Component({
  selector: "app-maintenance-provider",
  templateUrl: "./maintenance-provider.component.html",
  styleUrls: ["./maintenance-provider.component.scss"],
})
export class MaintenanceProviderComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<MaintenanceProvider>;

  constructor(
    public maintenanceProviderTableService: MaintenanceProviderTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Lifecycle Method

  ngOnInit(): void {
    this.tableConfig = this.maintenanceProviderTableService.getMaintenanceProviderTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddMaintenanceProvider = (): void => this.addMaintenanceProvider();

  // #endregion

  // #region Private methods

  private addMaintenanceProvider = (): void => {
    this.router.navigate(["/maintenance-providers/create"]);
  };

  // #endregion
}
